import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import Async from "react-select"
import moment from "moment"

//components
import Field from "../../Common/Field/Field"
import Button from "../../Buttons/Button"
// import ModuleHeader from '../ModuleHeader'

export default class SampleMain extends Component {
  state = {
    sampleRequest: {},
    //options
    SAMPLEREQUEST: {},
    disabled: false
  }

  componentWillMount() {
    const { sampleRequest, disabled, orderDate } = this.props

    this.setState({
      SAMPLEREQUEST: this.props.SAMPLEREQUEST,
      sampleRequest,
      disabled,
      orderDate
    })
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(this.state.SAMPLEREQUEST).length !=
      Object.keys(nextProps.SAMPLEREQUEST).length
    ) {
      this.setState({
        SAMPLEREQUEST: nextProps.SAMPLEREQUEST
      })
    }
    const { sampleRequest, disabled, orderDate } = nextProps
    this.setState({
      sampleRequest,
      disabled,
      orderDate
    })
  }

  getMagnumStyleNo = () => { }

  changeStyleNo = () => { }

  createSampleRequest = e => {
    e.preventDefault()
    let sampleRequest = { ...this.state.sampleRequest }
  }

  openModal = moduelname => { }

  render() {
    const { SAMPLEREQUEST, sampleRequest, orderDate } = this.state
    const { rights } = this.props
    // let gvnAllPermit, length = Object.keys(rights).length

    // let j = 0
    // Object.keys(rights).forEach((x) => {
    //   let keyname1 = x === "garmentTechnologist" ? "garmentTech" : x === 'qc' ? "QC" : x === 'signOff' ? 'signoff' : x
    //   if (rights[keyname1].web.create || rights[keyname1].web.edit) {
    //     j++
    //     if (j == length) {
    //       gvnAllPermit = true
    //     }
    //   }
    // })

    let gvnAllPermit
    Object.keys(rights.sampleRequest).forEach(x => {
      gvnAllPermit = rights.sampleRequest[x]
    })

    if (Object.keys(SAMPLEREQUEST).length > 0) {
      return (
        <div class="col-md-12">
          <div class="col-md-12 no-padding">
            <div class="col-md-2">
              <Field
                isFormGroup={true}
                inputType="select"
                inputName="originationOfRequest"
                value={sampleRequest.originationOfRequest}
                options={SAMPLEREQUEST.ORIGINATIONOFREQUEST}
                label={"Origination of Request *"}
                onChange={this.props.updateSampleRequest}
                disabled={this.state.disabled}
              />
            </div>
            <div class="col-md-2">
              <div className="form-group">
                <label>{"Buyer Name"}</label>
                <p>{sampleRequest.buyerName}</p>
              </div>
            </div>

            <div class="col-md-2">
              <div className="form-group">
                <label>{"Assistant Buyer"}</label>
                <p>{sampleRequest.assistantBuyer}</p>
              </div>
            </div>
            <div class="col-md-2">
              <div className="form-group">
                <label>{"Fabric Technologist"}</label>
                <p>{sampleRequest.fabricTechnologist}</p>
              </div>
            </div>
            <div class="col-md-2">
              <div className="form-group">
                <label>{"Garment Technologist"}</label>
                <p>{sampleRequest.garmentTechnology}</p>
              </div>
            </div>
            <div class="col-md-2">
              <div className="form-group">
                <label>{"Magnum Technologist"}</label>
                <p>{sampleRequest.magnumTechnologist}</p>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div className="form-group">
              <label>{"Date Created"}</label>
              <p>
                {moment(orderDate).format("HH:mm DD MMM YYYY")}
              </p>
            </div>
          </div>
          <div class="col-md-12 text-center">
            {!this.state.disabled && gvnAllPermit && (
              <Fragment>
                <Button
                  buttonName={"Create Request"}
                  buttonType={"save"}
                  onClick={this.props.createSample}
                />
                <Button
                  buttonName={"Duplicate"}
                  buttonType={"save"}
                  onClick={() => {
                    this.props.confirmDuplicate()
                  }}
                />
              </Fragment>
            )}
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}

SampleMain.propTypes = {}

SampleMain.defaultProps = {}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/SampleMain/index.js